import styled from 'styled-components';

const TextWrapper = styled.text`
  font-weight: bold;
  color: white;
  opacity: 0.6;
  text-align: right;
`;

export default TextWrapper;
